import React, { useEffect, useState, useCallback } from "react";
import "./GenerationFeedbackToast.css";

const GenerationFeedbackToast = ({ isOpen, onClose, template, generationId = null }) => {
  const [response, setResponse] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleClose = useCallback(() => {
    setResponse(null);
    onClose();
  }, [onClose]);

  useEffect(() => {
    if (isOpen) {
      // Auto-dismiss after 8 seconds if user doesn't interact
      const timer = setTimeout(() => {
        handleClose();
      }, 8000);
      return () => clearTimeout(timer);
    }
  }, [isOpen, handleClose]);

  const handleResponse = async (helpful) => {
    setSubmitting(true);
    try {
      const { data: { user } } = await (
        await import("../../supabaseClient/supabaseClient")
      ).default.auth.getUser();

      if (user) {
        const supabase = (
          await import("../../supabaseClient/supabaseClient")
        ).default;
        
        await supabase.from("generation_feedback").insert({
          user_id: user.id,
          template: template,
          generation_id: generationId,
          was_helpful: helpful,
          created_at: new Date(),
        });
      }
    } catch (error) {
      console.error("Error logging feedback:", error);
    } finally {
      setSubmitting(false);
      setResponse(helpful);
      setTimeout(() => handleClose(), 500);
    }
  };



  if (!isOpen) return null;

  return (
    <div className="generation-feedback-toast">
      <div className="toast-content">
        {response === null ? (
          <>
           <button className="toast-close" onClick={handleClose}>✕</button>
            <span className="toast-message">Did these questions match your needs?</span>
            <div className="toast-buttons">
              <button
                onClick={() => handleResponse(true)}
                disabled={submitting}
                className="toast-btn toast-btn-yes"
              >
                Yes
              </button>
              <button
                onClick={() => handleResponse(false)}
                disabled={submitting}
                className="toast-btn toast-btn-no"
              >
                No
              </button>
            </div>
          </>
        ) : (
          <span className="toast-message">
            {response ? "Great! Thanks for letting us know." : "We'll do better next time!"}
          </span>
        )}
      </div>
    </div>
  );
};

export default GenerationFeedbackToast;
